import * as React from "react";
import { BaseSelect } from "./BaseSelect";
import { MultipleSelect } from "./MultipleSelect";
import { ReadOnlySelect } from "./ReadonlySelect";
export function Select(props) {
  if (props.readonly) {
    return /*#__PURE__*/React.createElement(ReadOnlySelect, props);
  }
  if (props.multiple) {
    return /*#__PURE__*/React.createElement(MultipleSelect, props);
  }
  return /*#__PURE__*/React.createElement(BaseSelect, props);
}